// extracted by mini-css-extract-plugin
export var icon = "_al-3";
export var subtitle = "_al-2";
export var title = "_al-1";
export var value = "_al-0";